"use client"

import { datadogRum } from "@datadog/browser-rum"
import Image from "next/image"
import React, { useEffect } from "react"

import { sendGoogleAnalyticsEvent } from "@modules/common/utils/analytics"
import { APP_DOWNLOAD_STEP_TEXTS } from "@modules/signup-and-order-flow/components/signup/constants"

import StepWrapper from "../../common/StepWrapper"

interface AppDownloadStepProps {
  onClose: () => void
}

interface AppDownloadButtonProps {
  isIOS: boolean
}

const AppDownloadButton: React.FC<AppDownloadButtonProps> = ({ isIOS }) => {
  const appUrl = isIOS
    ? "https://apps.apple.com/mx/app/nelo/id1477987798"
    : "https://play.google.com/store/apps/details?id=co.nelo.nelo&gl=MX"

  return (
    <a
      href={appUrl}
      className="inline-block h-full w-full text-white"
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
    >
      Continúa en la app
    </a>
  )
}

const AppDownloadStep: React.FC<AppDownloadStepProps> = ({ onClose }) => {
  const appDownloadText = APP_DOWNLOAD_STEP_TEXTS

  useEffect(() => {
    sendGoogleAnalyticsEvent("SIGNUP_FLOW_PAGE_VIEW", {
      step: "APP_DOWNLOAD",
    })
    datadogRum.addAction(`signup.APP_DOWNLOAD`)
  }, [])

  const isIOS = typeof navigator !== "undefined" && /iPad|iPhone|iPod/.test(navigator.userAgent)
  const isAndroid = typeof navigator !== "undefined" && /android/i.test(navigator.userAgent)
  const isWeb = !(isIOS || isAndroid)

  return (
    <StepWrapper
      title={appDownloadText.title}
      subtitle={appDownloadText.subtitle}
      progressPercentage={100}
      onSubmit={(e) => {
        if (!isWeb) {
          e.preventDefault()
        } else {
          e.preventDefault()
          onClose()
        }
      }}
      showBackButton={true}
      onBack={onClose}
      submitButtonText={isWeb ? "" : <AppDownloadButton isIOS={isIOS} />}
    >
      {isWeb && (
        <div className="flex flex-col items-center">
          <Image src="/images/appDownload.svg" alt="QR Code" width={192} height={192} className="h-48 w-48 rounded-xl" />
        </div>
      )}
    </StepWrapper>
  )
}

export default AppDownloadStep
